const homeloadmore = () => {
    
    if( Math.ceil($(window).scrollTop()) >= $(document).height() - $(window).height() ) {

        setTimeout(function(){
            var container = $('.homeposts__list'),
            preloader = container.next('.homeposts__preloader'),
            offset = $('.homeposts__item').length,
            cat = container.attr('data-cat'),
            tag = container.attr('data-tag'),
            elems = [];

        if( container.length == 1 ){

            $.ajax({
                url:FR.ajax_url,
                data: "action=load_more_on_scroll&offset="+offset+'&cat='+cat+'&tag='+tag,
                type:'POST',
                success: function(data){
                    if( data.html != '' ){
                        $.each(data.html, function(key, item){
                            elems.push(item);   
                        });
                        container.append(elems);
                    }else{
                        preloader.fadeOut(300, function(){
                            $(this).remove();
                        })
                    }  

                },
                error: function(){
                    console.log('error');
                }
            });

            return false;

        }
        },300)

    }
 }

 module.exports = {
    homeloadmore, 
 };